import SheetFiltersItem from "@/common/components/SheetFiltersItem";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipments } from "@/features/equipments/hooks/useEquipments";
import { EquipmentsTransformer } from "@/features/equipments/services/equipmentTransformer";

const DashboardFilterEquipmentSheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: equipmentOptions,
  } = useEquipments({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EquipmentsTransformer.optionsTransformer({
        showIcon: false,
      })
    }),
  });

  return (
    <SheetFiltersItem
      label={dashboardFilters[DashboardFilters.Equipment]}
      value={filters[DashboardFilters.Equipment]?.value || ''}
      options={[{ label: 'Todas', value: '' }, ...equipmentOptions]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [DashboardFilters.Equipment]: value }))}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterEquipmentSheet;
